import { Inject, Injectable } from '@angular/core';
import { NotificationDataInstanceToken, NotificationDataInterface, NotificationModel } from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';

@Injectable({
    providedIn: 'root',
})
export class OverviewService {
    private currentNotificationIndex = -1;
    private notificationsList: NotificationModel[] = [];
    public constructor(
        @Inject(NotificationDataInstanceToken) private readonly notificationService: NotificationDataInterface,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
    ) {}

    public getCurrentNotificationIndex(): number {
        return this.currentNotificationIndex;
    }

    public setCurrentNotificationIndex(notification: NotificationModel): void {
        this.currentNotificationIndex = this.notificationsList.findIndex((notificationModel) =>
            notificationModel.identifier.equalsTo(notification.identifier),
        );
    }

    public resetCurrentNotificationIndex(): void {
        this.currentNotificationIndex = -1;
    }

    public getNotificationList(): NotificationModel[] {
        return this.notificationsList;
    }

    public setNotificationList(): void {
        const notificationList: Array<Promise<[NotificationModel, boolean]>> = this.notificationService
            .getTodaysNotifications()
            .concat(this.notificationService.getUpcomingNotifications())
            .concat(this.notificationService.getNewNotifications())
            .map(async (notification) => {
                // If a notification is cancelled, then its details screen should not be shown.
                const notificationStatus = this.notificationService.getStatus(notification);
                const result: [NotificationModel, boolean] = [
                    notification,
                    !(
                        notificationStatus.isCancelled() ||
                        (this.notificationService.isNotificationCancelled(notification) &&
                            !(await this.notificationService.getCancellationConfirmationForInprogress(
                                notification.identifier,
                            )))
                    ),
                ];
                return result;
            });
        Promise.all(notificationList)
            .then((results) => {
                this.notificationsList = results
                    .filter((notification) => notification[1])
                    .map((notification) => notification[0]);
            })
            .catch((error) => {
                this.log.error(this.constructor.name, 'setNotificationList: Error setting notification list', error);
            });
    }
}
